import * as React from 'react';

import { Input, InputNumber } from 'antd';
import { NiInput, NiSelect } from '@component/index';

import '@style/component/form-group/index.less';

export const FormGroup = (props: any) => {
  return (
    <div
      className="form-group"
    >
      <label
        style={{
          flex: '0 170px'
        }}
      >
        {props.title}
      </label>
      {(() => {
        switch (props.type) {
          case '':
          case undefined:
          case 'input':
            return (
              <Input
                style={{
                  flex: 1
                }}
                disabled={props.disabled}
                value={props.value}
                onChange={props.onChange}
              />
            );

          case 'password':
            return (
              <NiInput.Password
                prefix={undefined}
                disabled={props.disabled}
                style={{
                  flex: 1
                }}
                value={props.value}
                onChange={props.onChange}
              />
            );

          case 'select':
            return (
              <NiSelect
                disabled={props.disabled}
                style={{
                  width: 144
                }}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
              >
                {props.options.map((option: any) => (
                  <NiSelect.Option
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </NiSelect.Option>
                ))}
              </NiSelect>
            );
          case 'number':
            return (
              <InputNumber
                disabled={props.disabled}
                style={{
                  flex: 1,
                  border: '1px solid rgba(0,0,0,0.06)'
                }}
                value={props.value}
                onChange={props.onChange}
              />
            );
          case 'custom':
            return props.custom;
          default:
            return undefined;
        }
      })()}
    </div>
  );
};
